import { IMPERSONATE } from '../types';
import getImpersonationFromLS from '../../common/utility/getImpersonationFromLS';

const initialState = {
  canImpersonate: false,
  impersonate: Boolean(getImpersonationFromLS().impersonate),
  impersonateId: getImpersonationFromLS().impersonateId,
  impersonateName: getImpersonationFromLS().impersonateName,
};

const impersonateReducer = (state = initialState, action) => {
  switch (action.type) {
    case IMPERSONATE.IMPERSONATE_ON:
      return {
        ...state,
        impersonate: true,
      };
    case IMPERSONATE.IMPERSONATE_OFF:
      return {
        ...state,
        impersonate: false,
        impersonateId: '',
        impersonateName: '',
      };

    case IMPERSONATE.SET_IMPERSONATE_ID:
      return {
        ...state,
        impersonateId: action.value,
      };

    case IMPERSONATE.SET_IMPERSONATE_NAME:
      return {
        ...state,
        impersonateName: action.value,
      };

    case IMPERSONATE.CAN_IMPERSONATE:
      return {
        ...state,
        canImpersonate: action.value,
      };

    default:
      return state;
  }
};

export default impersonateReducer;
